import React from 'react';
import { SvgIcon } from 'core/icons';
import { useTranslate } from 'core/translate';

const FullPageCompareHeader = ({ analyticsKey, title, onClose }) => {
  const translate = useTranslate();
  return (
    <div className="modal-header modal-header--sticky">
      <h2 className="modal-header__title">{title}</h2>
      <a
        className="modal-header__close stat-button-close"
        href="#!"
        onClick={onClose}
        data-dtm={analyticsKey}
        aria-label={translate('byo.page.general.close')}>
        <SvgIcon name="close" className="modal-header__close-icon--large" />
      </a>
    </div>
  );
};

export default FullPageCompareHeader;
